import { KeyRoundIcon, UnplugIcon, UserIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { ConnectedAppsTable } from '@/features/connected-apps';
import { AdminPageShell } from '../AdminPageShell';

export const ConnectedAppsPage = () => {
  const { t } = useTranslation('admin');

  return (
    <AdminPageShell
      title={t('connectedApps.connectedAppsPage.connectedApps')}
      about={{
        title: t('connectedApps.connectedAppsPage.about.title'),
        description: t('connectedApps.connectedAppsPage.about.description'),
        rows: [
          {
            icon: KeyRoundIcon,
            text: t('connectedApps.connectedAppsPage.about.accessYouGranted'),
          },
          {
            icon: UnplugIcon,
            text: t('connectedApps.connectedAppsPage.about.disconnectRevokes'),
          },
          { icon: UserIcon, text: t('connectedApps.connectedAppsPage.about.onlyYourOwn') },
        ],
      }}
    >
      <ConnectedAppsTable />
    </AdminPageShell>
  );
};
